import { createStore } from "owa-satcheljs";

interface SuiteHeaderStore {
    isRendered: boolean;
    isShy: boolean;
    currentFlexPaneState: FlexPaneState; // State of currently shown FlexPane
    flexPaneStateMap: Map<string /* flexPaneId */, FlexPaneState>;
}

export interface FlexPaneState {
    isShown: boolean;
    isExpanded: boolean;
    expandedWidth: number;
}

export const getStore: () => SuiteHeaderStore = createStore<SuiteHeaderStore>("suiteHeaderStore", {
    isRendered: false,
    isShy: false,
    currentFlexPaneState: {
        isShown: false,
        isExpanded: false,
        expandedWidth: 0,
    },
    flexPaneStateMap: new Map<string /* flexPaneId */, FlexPaneState>(),
});
